import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const BranchContext = createContext(null);

export function BranchProvider({ children }) {
  const { user } = useAuth();
  const [branches, setBranches] = useState([]);
  const [activeBranchId, setActiveBranchIdState] = useState(() => localStorage.getItem("active_branch_id"));
  const [loading, setLoading] = useState(true);

  const setActiveBranchId = useCallback((id) => {
    setActiveBranchIdState((prev) => {
      const val = typeof id === "function" ? id(prev) : id;
      if (val) localStorage.setItem("active_branch_id", val);
      return val;
    });
  }, []);

  const loadBranches = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/branches");
      setBranches(data);
      setActiveBranchId((prev) => {
        if (prev && data.some((b) => b.id === prev)) return prev;
        if (user && user.role === "staff") return user.branch_id;
        const def = data.find((b) => b.is_default) || data[0];
        return def ? def.id : null;
      });
    } finally {
      setLoading(false);
    }
  }, [user, setActiveBranchId]);

  useEffect(() => {
    if (user && user.role) loadBranches();
  }, [user, loadBranches]);

  const activeBranch = branches.find((b) => b.id === activeBranchId) || null;

  return (
    <BranchContext.Provider
      value={{ branches, activeBranch, activeBranchId, setActiveBranchId, loadBranches, loading }}
    >
      {children}
    </BranchContext.Provider>
  );
}

export const useBranch = () => useContext(BranchContext);
